/**
 * InviteCard component
 * Square card shown last in the friends grid; opens the invite flow on press.
 * Uses ActionCard for consistent styling with AddGroupCard.
 */

import React from 'react'
import { UserPlus } from 'lucide-react-native'
import { ActionCard } from '../ActionCard/ActionCard'

interface InviteCardProps {
  cardWidth: number
  onPress: () => void
  /** Pin to an exact height instead of the default friend-card aspect ratio (e.g. next to RivalCards). */
  height?: number
  testID?: string
}

export const InviteCard: React.FC<InviteCardProps> = ({
  cardWidth: _cardWidth,
  onPress,
  height,
  testID = 'invite-card',
}) => {
  return (
    <ActionCard
      iconName={UserPlus}
      label="Invite"
      onPress={onPress}
      height={height}
      testID={testID}
    />
  )
}
